import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

interface ModalHeaderStyleProps {
  isSearchBar?: boolean;
  removeBottomBorder?: boolean;
  applyBlockPadding?: boolean;
}

export const HeaderContent = styled.header<ModalHeaderStyleProps>`
  width: ${({ isSearchBar }) => (isSearchBar ? 'calc(100% - 30px)' : 'calc(100% - 26px)')};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--space-10) var(--space-10) var(--space-10)
    ${({ isSearchBar }) => (isSearchBar ? 'var(--space-20)' : 'var(--space-16)')};
  gap: var(--space-12);
  box-shadow: ${({ removeBottomBorder }) => (removeBottomBorder ? 'none' : 'var(--bottom-border)')};
`;

export const HeaderLeftSection = styled.div<ModalHeaderStyleProps>`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-8);
  padding-block: ${({ applyBlockPadding }) => (applyBlockPadding ? 'var(--space-2)' : 'var(--space-0)')};
  ${mobile_xl(css<ModalHeaderStyleProps>`
    padding-block: ${({ applyBlockPadding }) => (applyBlockPadding ? 'var(--space-1)' : 'var(--space-0)')};
  `)}
`;

export const Icon = styled.div`
  ${FlexCenter}
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;

export const Title = styled.p`
  margin: var(--space-0);
  ${Typography.heading_md}
  color: var(--text-primary);
`;

export const Description = styled.p`
  margin: var(--space-0);
  ${Typography.body_sm}
  color: var(--text-secondary);
`;

export const SearchBar = styled.input`
  width: 100%;
  margin: var(--space-0);
  padding: var(--space-0);
  border: none;
  background-color: var(--background-primary);
  ${Typography.body_lg}
  color: var(--text-primary);

  &::placeholder {
    color: var(--text-placeholder);
  }

  &:focus {
    outline: none;
  }
`;
